import { createTheme } from "@mui/material/styles";
import { colorTokens } from "../styles/tokens";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 13,
  },
  palette: {
    primary: { main: colorTokens.accent },
    background: {
      default: colorTokens.backgroundPrimary,
      paper: colorTokens.backgroundPrimary,
    },
    divider: colorTokens.border,
    text: {
      primary: colorTokens.textPrimary,
      secondary: colorTokens.textSecondary,
    },
    custom: {
      appbar: colorTokens.appbarBackground,
      footer: colorTokens.footerBackground,
      panelChrome: colorTokens.panelHeaderBackground,
      sidebar: colorTokens.sidebarBackground,
      sidebarText: colorTokens.sidebarText,
      sidebarActiveText: colorTokens.sidebarActiveText,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { margin: 0 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { backgroundColor: "#fff" },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: { backgroundColor: "#fff" },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: { backgroundColor: "#fff" },
      },
    },
  },
});

export default theme;
